import React from 'react';
import { motion } from 'framer-motion';
import { Download, FileCheck, Clock, Zap } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function HeroSection() {
  return <section className="bg-gradient-to-b from-slate-900 to-slate-800 text-white pt-24 pb-16 px-4" data-id="element-136">
      <div className="max-w-5xl mx-auto text-center" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-block bg-orange-500/15 border border-orange-500/40 text-orange-300 text-xs md:text-sm font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-6" data-id="element-138">
          🐾 Limited-Time Reset Offer
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-139">
          The 15-Minute{' '}
          <span className="text-orange-400" data-id="element-140">Separation Anxiety RESET</span>{' '}
          Protocol
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="text-xl md:text-2xl font-bold text-white mb-4 max-w-3xl mx-auto leading-snug" data-id="element-141">
          Stop the barking, the crying, and the destruction —{' '}
          <span className="text-orange-400" data-id="element-142">
            for less than the cost of a dog toy.
          </span>
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} className="text-base md:text-lg text-slate-300 mb-8 max-w-2xl mx-auto" data-id="element-143">
          The science-backed protocol that has helped over{' '}
          <span className="font-semibold text-orange-400" data-id="element-144">
            5,000+ frustrated dog owners
          </span>{' '}
          in the USA reclaim their freedom — in just 15 minutes a day.
        </motion.p>

        <motion.a href="https://floctiva.com/cart/53021114695996:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="relative inline-flex items-center justify-center gap-2 bg-gradient-to-b from-orange-400 to-orange-600 hover:from-orange-500 hover:to-orange-700 text-white font-extrabold text-lg md:text-2xl px-8 md:px-14 py-5 md:py-6 rounded-full shadow-[0_10px_40px_rgba(249,115,22,0.5)] mb-3 transition-all duration-300 cursor-pointer ring-4 ring-orange-500/30 hover:ring-orange-500/50 animate-pulse" data-id="element-145">
          <Zap className="w-6 h-6 fill-white" data-id="element-146" />
          GET INSTANT ACCESS FOR JUST $17
        </motion.a>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-sm text-slate-400 mb-12" data-id="element-147">
          <span className="line-through" data-id="element-148">$37</span>{' '}
          <span className="text-orange-300 font-semibold ml-2" data-id="element-149">
            SAVE $20 — Today Only
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.55
      }} className="mb-12" data-id="element-150">
          <img src="https://cdn.magicpatterns.com/uploads/qyf85fyy6f9zFah9GnHsVU/pagina_principal.png" alt="The 15-Minute Separation Anxiety RESET Protocol" className="mx-auto max-w-md md:max-w-lg lg:max-w-xl w-full rounded-2xl drop-shadow-[0_0_40px_rgba(249,115,22,0.3)]" data-id="element-151" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.7
      }} className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto" data-id="element-152">
          <div className="flex flex-col items-center gap-2 bg-slate-800/50 border border-slate-700 rounded-xl p-4" data-id="element-153">
            <Download className="w-6 h-6 text-orange-400" data-id="element-154" />
            <span className="text-sm font-semibold" data-id="element-155">
              Instant Digital Download
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 bg-slate-800/50 border border-slate-700 rounded-xl p-4" data-id="element-156">
            <FileCheck className="w-6 h-6 text-orange-400" data-id="element-157" />
            <span className="text-sm font-semibold" data-id="element-158">
              Step-by-Step Checklist
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 bg-slate-800/50 border border-slate-700 rounded-xl p-4" data-id="element-159">
            <Clock className="w-6 h-6 text-orange-400" data-id="element-160" />
            <span className="text-sm font-semibold" data-id="element-161">
              48-Hour "Calm" Guarantee
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 bg-slate-800/50 border border-slate-700 rounded-xl p-4" data-id="element-162">
            <Zap className="w-6 h-6 text-orange-400" data-id="element-163" />
            <span className="text-sm font-semibold" data-id="element-164">
              No Long Reading Required
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}